import { render } from "./WelcomePage.vue?vue&type=template&id=958982de&scoped=true"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"

import "./WelcomePage.vue?vue&type=style&index=0&id=958982de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958982de"],['__file',"src/components/WelcomePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "958982de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('958982de', __exports__)) {
    api.reload('958982de', __exports__)
  }
  
  module.hot.accept("./WelcomePage.vue?vue&type=template&id=958982de&scoped=true", () => {
    api.rerender('958982de', render)
  })

}


export default __exports__